var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.unreadCount > 0),expression:"unreadCount > 0"}],staticClass:"bg-primary round"},[_vm._v("\n    "+_vm._s(_vm.unreadCount)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }